import React, { useState, useEffect, useMemo } from "react";

const ShowMoreHTML = ({ body }) => {
  const [expanded, setExpanded] = useState(false);
  const [shouldTruncate, setShouldTruncate] = useState(false);

  const getTextFromHTML = (html) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const wordCount = useMemo(() => {
    const text = getTextFromHTML(body);
    return text.trim().split(/\s+/).length;
  }, [body]);

  useEffect(() => {
    setShouldTruncate(wordCount > 100);
  }, [wordCount]);

  const getTruncatedHTML = (html, maxWords = 100) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    let count = 0;

    const truncateNode = (node) => {
      if (count >= maxWords) return null;

      if (node.nodeType === Node.TEXT_NODE) {
        const words = node.textContent.trim().split(/\s+/);
        if (count + words.length <= maxWords) {
          count += words.length;
          return node.cloneNode();
        } else {
          const allowed = maxWords - count;
          const truncated = words.slice(0, allowed).join(" ") + "…";
          count = maxWords;
          const newNode = document.createTextNode(truncated);
          return newNode;
        }
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        const clone = node.cloneNode(false);
        for (let child of node.childNodes) {
          const newChild = truncateNode(child);
          if (newChild) clone.appendChild(newChild);
          if (count >= maxWords) break;
        }
        return clone;
      }

      return null;
    };

    const fragment = document.createDocumentFragment();
    for (let child of div.childNodes) {
      const newChild = truncateNode(child);
      if (newChild) fragment.appendChild(newChild);
      if (count >= maxWords) break;
    }

    const wrapper = document.createElement("div");
    wrapper.appendChild(fragment);
    return wrapper.innerHTML;
  };

  const truncatedHTML = useMemo(() => {
    if (!shouldTruncate) return body;
    return getTruncatedHTML(body, 100);
  }, [body, shouldTruncate]);

  return (
    <div>
      <div
        className="text-justify ql-editor"
        dangerouslySetInnerHTML={{
          __html: expanded || !shouldTruncate ? body : truncatedHTML,
        }}
      />

      {shouldTruncate && (
        <button
          onClick={() => setExpanded((prev) => !prev)}
          className="mt-2 bg-primary px-5 py-2 text-white rounded-lg transition delay-150 duration-300 ease-in-out hover:-translate-y-1 hover:scale-130"
        >
          {expanded ? "کمتر" : "بیشتر"}
        </button>
      )}
    </div>
  );
};

export default ShowMoreHTML;